import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Button } from '../Button';
import { Close } from '../Close';
import { Heading } from '../Heading';
import useIsMobile from '../Utils/customHooks/useIsMobile';
import styles from '@dtsl/css-simple-modal/dist/index.module.css';
const SimpleModal = props => {
  const {
    title = '',
    isVisible = false,
    closeModal = () => {},
    primaryAction = null,
    secondaryAction = null,
    backdropClosable = false
  } = props;
  const modalRef = React.useRef(null);
  const [showModal, setShowModal] = useState(isVisible);
  const {
    isMobile
  } = useIsMobile(476);
  const onAnimationEnd = () => {
    if (!isVisible) ReactDOM.flushSync(() => {
      setShowModal(false);
    });
  };
  const handleDocumentClick = e => {
    if (modalRef && modalRef.current) {
      if (!modalRef.current.contains(e.target)) isVisible && backdropClosable && closeModal();
    }
  };
  useEffect(() => {
    const handleEscKey = event => {
      if (event.keyCode === 27) {
        isVisible && closeModal();
      }
    };
    if (isVisible) {
      setShowModal(true);
    }
    if (isVisible) {
      document.body.classList.add(styles['sib-simple-modal-active']);
    } else {
      document.body.classList.remove(styles['sib-simple-modal-active']);
    }
    document.addEventListener('keydown', handleEscKey, false);
    document.addEventListener('click', handleDocumentClick, false);
    return () => {
      document.removeEventListener('keydown', handleEscKey, false);
      document.removeEventListener('click', handleDocumentClick, false);
    };
  }, [isVisible]);
  return showModal && /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles['sib-simple-modal']
  }, /*#__PURE__*/React.createElement("div", {
    ref: modalRef,
    className: styles['sib-modal-content'],
    onAnimationEnd: onAnimationEnd,
    style: {
      animation: `${isVisible ? isMobile ? 'var(--sib-transition_slide-modal-to-top, slide-modal-to-top 350ms ease-in)' : 'var(--sib-transition_fade-in-modal, fade-in-modal 350ms ease-in-out)' : isMobile ? 'var(--sib-transition_slide-modal-to-bottom, 350ms slide-modal-to-bottom ease-in-out)' : 'var(--sib-transition_fade-out-modal, 350ms fade-out-modal ease-in-out)'}`
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['sib-modal-header']
  }, /*#__PURE__*/React.createElement(Heading, {
    className: styles['modal-title'],
    fontFamily: "primary"
  }, title), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Close, {
    onClick: closeModal,
    className: styles['modal-close-btn']
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['modal-description-container']
  }, props.children), /*#__PURE__*/React.createElement("footer", {
    className: styles['modal-actions-container']
  }, secondaryAction ? /*#__PURE__*/React.createElement(Button, secondaryAction) : null, primaryAction ? /*#__PURE__*/React.createElement(Button, primaryAction) : null))), /*#__PURE__*/React.createElement("div", {
    className: styles['sib-modal-backdrop'],
    onAnimationEnd: onAnimationEnd,
    style: {
      animation: `${isVisible ? 'var(--sib-transition_backdrop-open-modal, backdrop-open 350ms ease-in-out)' : 'var(--sib-transition_backdrop-close-modal, backdrop-close 350ms ease-in-out)'}`
    }
  })), document.body);
};
SimpleModal.propTypes = {
  title: PropTypes.string,
  secondaryAction: PropTypes.shape({
    variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'destructive']),
    label: PropTypes.string,
    iconAlone: PropTypes.bool,
    icon: PropTypes.node,
    ellipsis: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.bool,
    tooltipValue: PropTypes.object,
    dropdownOpen: PropTypes.bool,
    showArrowIcon: PropTypes.bool,
    className: PropTypes.string
  }),
  primaryAction: PropTypes.shape({
    variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'destructive']),
    label: PropTypes.string,
    iconAlone: PropTypes.bool,
    icon: PropTypes.node,
    ellipsis: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.bool,
    tooltipValue: PropTypes.object,
    dropdownOpen: PropTypes.bool,
    showArrowIcon: PropTypes.bool,
    className: PropTypes.string
  }),
  isVisible: PropTypes.bool,
  closeModal: PropTypes.func,
  children: PropTypes.node.isRequired,
  backdropClosable: PropTypes.bool
};
export default SimpleModal;